import $ from 'jquery'

$(document).ready(function() {
  // Scope variables to prevent global pollution
  const autoplay = '?autoplay=1'

  // Initialize each video teaser independently
  $('.dhsv_vc_teaser_video').each(function() {
    const $teaser = $(this)
    const $videoBlock = $teaser.find('.video_block')
    const $video = $teaser.find('.video')
    const $videoPlay = $teaser.find('.video_play')
    const $videoStop = $teaser.find('.video_stop')
    const $videoThumbnail = $teaser.find('.video_thumbnail')
    const $backgroundVideo = $teaser.find('#background_video')

    // Play button click handler
    $videoPlay.on('click', function(e) {
      e.preventDefault()
      e.stopPropagation()

      // Handle YouTube/Vimeo videos
      if ($video.length) {
        // Check if Borlabs Cookie is blocking the iframe
        const $borlabsBlock = $video.find('._brlbs-cb-youtube')
        const $borlabsButton = $video.find('._brlbs-btn')

        if ($borlabsBlock.length && $borlabsButton.length) {
          // Borlabs Cookie is active - trigger the consent button
          $borlabsButton.trigger('click')

          // Listen for Borlabs Cookie unblock event
          $(document).on('borlabsCookieUnblock', function(event, data) {
            if (
              data &&
              data.type === 'content-blocker' &&
              data.id === 'youtube'
            ) {
              // YouTube iframe has been unblocked
              setTimeout(() => {
                const iframe = $video.find('iframe')[0]
                if (iframe && iframe.src) {
                  // Add autoplay to the newly loaded iframe
                  if (iframe.src.indexOf('autoplay') === -1) {
                    iframe.src += autoplay
                  }
                  // Hide custom controls for YouTube/Vimeo - let iframe controls take over
                  $videoThumbnail.fadeOut()
                  $videoPlay.fadeOut()
                  $videoStop.hide() // Hide stop button for YouTube/Vimeo
                  $videoBlock.addClass('active')
                }
              }, 100)
            }
          })

          // Fallback: Wait for iframe to load after consent (in case event doesn't fire)
          const checkForIframe = setInterval(() => {
            const iframe = $video.find('iframe')[0]
            if (iframe && iframe.src) {
              clearInterval(checkForIframe)
              // Add autoplay to the newly loaded iframe
              if (iframe.src.indexOf('autoplay') === -1) {
                iframe.src += autoplay
              }
              // Hide custom controls for YouTube/Vimeo - let iframe controls take over
              $videoThumbnail.fadeOut()
              $videoPlay.fadeOut()
              $videoStop.hide() // Hide stop button for YouTube/Vimeo
              $videoBlock.addClass('active')
            }
          }, 100)

          // Fallback timeout after 5 seconds
          setTimeout(() => {
            clearInterval(checkForIframe)
          }, 5000)

          return // Exit early for Borlabs consent flow
        }

        // Handle normal YouTube/Vimeo videos (no Borlabs)
        if ($video.find('iframe').length) {
          const iframe = $video.find('iframe')[0]
          if (iframe.src.indexOf('autoplay') === -1) {
            iframe.src += autoplay
          }
          // Hide custom controls for YouTube/Vimeo - let iframe controls take over
          $videoThumbnail.fadeOut()
          $videoPlay.fadeOut()
          $videoStop.hide() // Hide stop button for YouTube/Vimeo
          $videoBlock.addClass('active')
          return // Exit early for YouTube/Vimeo
        }
      }

      // Handle local video files
      if ($backgroundVideo.length) {
        $backgroundVideo[0].play()
        $videoThumbnail.fadeOut()
        $videoPlay.fadeOut()
        $videoBlock.addClass('active')
      }
    })

    // Stop button click handler (only for local videos)
    $videoStop.on('click', function(e) {
      e.preventDefault()
      e.stopPropagation()

      // Only handle local videos
      if ($backgroundVideo.length) {
        $backgroundVideo[0].pause()
        $videoBlock.removeClass('active')
        $videoPlay.fadeIn()
      }
    })
  })
})
